import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { PropertyHighlights } from './components/PropertyHighlights';
import { GallerySection } from './components/GallerySection';
import { LocationSection } from './components/LocationSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-black text-brand-cream font-sans selection:bg-brand-gold selection:text-brand-black" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PropertyHighlights data-id="element-4" />
        <GallerySection data-id="element-5" />
        <LocationSection data-id="element-6" />
        <ContactSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}